import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthProvider';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: apiBaseUrl,
});

 // Add response interceptor
 api.interceptors.response.use(
  (response) => {
    // Example: Log successful responses
    console.log('Response:', response);
    return response;
  },
  (error) => {
    // Handle errors like 401 or 500
    if (error.response) {
      console.error(`Error ${error.response.status}: ${error.response.data}`);
      if (error.response.status === 401) {
        //alert('Session expired. Redirecting to login.');
        Swal.fire({ title: "Session expired !", text: "Please login again to continue.", icon: "error", confirmButtonText: "OK" }).then(
          () => {

            localStorage.clear();
            window.location.href = '/login';
          }
        );
        //navigate("/login");
      }
    } else {
      console.error('Network error or server not responding:', error);
    }
    return Promise.reject(error);
  }
);


const ApiStoreContext = createContext();

const ApiStoreProvider = ({ children }) => {
  const { token } = useAuth();
  const [authToken, setAuthToken] = useState(token);
  const navigate = useNavigate();

 

  useEffect(() => {
    const scrollStep = -window.scrollY / (15 / 15);
    if (window.scrollY !== 0) {
      window.scrollBy(0, scrollStep);
    }
  })

  useEffect(() => {
    setAuthToken(token);
  }, [token]);

  const apiStore = {
    get: async (endpoint, params) => {
      try {
        const response = await api.get(endpoint, {
          params,
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        return response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
      }
    },

    post: async (endpoint, data) => {
      try {
        const response = await api.post(endpoint, data, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        return response.data;
      } catch (error) {
        // if(error.status==401){
        //   alert('Session expired');
        //   navigate("/login");
        // }
        console.error('Error creating data:', error);
        throw error;
      }
    },

    put: async (endpoint, data) => {
      try {
        const response = await api.put(endpoint, data, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        return response.data;
      } catch (error) {
        console.error('Error updating data:', error);
        throw error;
      }
    },

    delete: async (endpoint, params) => {
      try {
        const response = await api.delete(endpoint, {
          params,
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        return response.data;
      } catch (error) {
        console.error('Error deleting data:', error);
        throw error;
      }
    },

    postFormData: async (endpoint, formData) => {
      try {
        const response = await api.post(endpoint, formData, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'multipart/form-data',
          },
        });
        return response.data;
      } catch (error) {
        console.error('Error creating form data:', error);
        throw error;
      }
    },

    getBlob: async (endpoint, params) => {
      try {
        const response = await api.get(endpoint, {
          params,
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        return response.data;
      } catch (error) {
        console.error('Error fetching blob:', error);
        throw error;
      }
    },
  };

  return (
    <ApiStoreContext.Provider value={apiStore}>
      {children}
    </ApiStoreContext.Provider>
  );
};

export default ApiStoreProvider;
export const useApiStore = () => useContext(ApiStoreContext);